import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IUniverseIconProps, UniverseIconVariant } from './index';

export default function TingleUniverseIcon({
  color,
  className,
  size = 16,
  rotate,
  flip,
  variant = UniverseIconVariant.DEFAULT,
}: IUniverseIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === UniverseIconVariant.DEFAULT && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.48 3.46889C7.78641 2.66029 5.41922 2.2642 2.25 2.25014C1.95111 2.24607 1.65809 2.33323 1.41 2.49998C1.20637 2.63762 1.03968 2.82319 0.924597 3.04036C0.809512 3.25754 0.749555 3.49966 0.750002 3.74545V17.1564C0.750002 18.0629 1.395 18.7469 2.25 18.7469C5.58141 18.7469 8.92313 19.0581 10.9247 20.95C10.9521 20.976 10.9865 20.9934 11.0237 21C11.0608 21.0066 11.0991 21.0021 11.1338 20.9871C11.1684 20.9721 11.1979 20.9473 11.2186 20.9157C11.2393 20.8841 11.2502 20.8471 11.25 20.8094V5.00732C11.2501 4.90071 11.2273 4.79532 11.1831 4.69828C11.139 4.60124 11.0745 4.5148 10.9941 4.44482C10.5356 4.05287 10.0263 3.72459 9.48 3.46889Z"
            fill={theme.color.icon.icon_2}
          />
          <path
            d="M22.59 2.49861C22.3418 2.33227 22.0488 2.24561 21.75 2.25017C18.5808 2.26423 16.2136 2.65845 14.52 3.46892C13.9737 3.72417 13.4643 4.0518 13.0055 4.44298C12.9252 4.51309 12.8609 4.59955 12.8168 4.69657C12.7728 4.7936 12.75 4.89893 12.75 5.00548V20.8085C12.75 20.8447 12.7607 20.8802 12.7807 20.9104C12.8008 20.9407 12.8293 20.9643 12.8628 20.9784C12.8962 20.9924 12.9331 20.9963 12.9687 20.9895C13.0044 20.9827 13.0372 20.9656 13.0631 20.9402C14.2664 19.7449 16.3781 18.7455 21.7519 18.746C22.1497 18.746 22.5312 18.5879 22.8125 18.3066C23.0938 18.0253 23.2519 17.6438 23.2519 17.246V3.74595C23.2524 3.49968 23.1923 3.25707 23.0769 3.03953C22.9615 2.82199 22.7942 2.63621 22.59 2.49861Z"
            fill={theme.color.icon.icon_2}
          />
        </svg>
      )}
      {variant === UniverseIconVariant.CARTOON && ( // 추후 light 모드 작업되면 수정되어야 함.
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill={theme.color.line.line_1} />
          <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke={theme.color.line.line_1} />
          <path
            d="M13.9 8.89074C12.4887 8.21691 10.516 7.88683 7.875 7.87511C7.62593 7.87173 7.38174 7.94436 7.175 8.08332C7.00531 8.19802 6.8664 8.35266 6.7705 8.53363C6.67459 8.71461 6.62463 8.91639 6.625 9.12121V20.297C6.625 21.0525 7.1625 21.6224 7.875 21.6224C10.6512 21.6224 13.4359 21.8818 15.1039 23.4583C15.1267 23.48 15.1554 23.4945 15.1864 23.5C15.2174 23.5055 15.2493 23.5017 15.2782 23.4893C15.307 23.4768 15.3316 23.4561 15.3488 23.4297C15.3661 23.4034 15.3752 23.3726 15.375 23.3411V10.1728C15.3751 10.0839 15.3561 9.9961 15.3193 9.91523C15.2825 9.83436 15.2287 9.76234 15.1617 9.70402C14.7797 9.37739 14.3553 9.10383 13.9 8.89074Z"
            fill={theme.color.icon.icon_2}
          />
          <path
            d="M24.825 8.08217C24.6182 7.94356 24.374 7.87134 24.125 7.87514C21.484 7.88686 19.5113 8.21538 18.1 8.89077C17.6448 9.10347 17.2203 9.3765 16.8379 9.70249C16.771 9.76091 16.7174 9.83296 16.6807 9.91381C16.644 9.99466 16.625 10.0824 16.625 10.1712V23.3404C16.625 23.3706 16.6339 23.4002 16.6506 23.4254C16.6673 23.4506 16.6911 23.4703 16.719 23.482C16.7469 23.4937 16.7776 23.4969 16.8073 23.4913C16.837 23.4856 16.8643 23.4713 16.8859 23.4501C17.8887 22.454 19.6484 21.6212 24.1266 21.6216C24.4581 21.6216 24.776 21.4899 25.0104 21.2555C25.2449 21.0211 25.3766 20.7031 25.3766 20.3716V9.12163C25.377 8.9164 25.3269 8.71422 25.2307 8.53294C25.1346 8.35165 24.9952 8.19684 24.825 8.08217Z"
            fill={theme.color.icon.icon_2}
          />
        </svg>
      )}
    </i>
  );
}
